import { render, staticRenderFns } from "./TaskSettings.vue?vue&type=template&id=ae11a5c0&scoped=true"
import script from "./TaskSettings.vue?vue&type=script&lang=js"
export * from "./TaskSettings.vue?vue&type=script&lang=js"
import style0 from "./TaskSettings.vue?vue&type=style&index=0&id=ae11a5c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae11a5c0",
  null
  
)

export default component.exports